import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
    icon: string;
    title: string;
    body: string;
    btns_lst: any
}

@Component({
    selector: 'custom-dialog',
    templateUrl: './custom_dailog.html',
})
export class CustomDialougeBox {
    // data;
    constructor(
        public dialogRef: MatDialogRef<CustomDialougeBox>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {
        if (data && data['btns_lst'] && data['btns_lst'].length) {
            data['btns_lst'].filter((k) => {
                console.log(k, 'buttonnnnnnnnnnnnnnnnnn');

                if (k['title']) {
                    k['color'] = 'blue';
                    let text = '' + k['title']
                    let ok_result = text.match(/ok/gi) || text.match(/yes/gi) || text.match(/confirm/gi) || text.match(/save/gi) || text.match(/activate/gi);
                    if (ok_result) {
                        k['backgroundColor'] = '#65a30d';
                        k['textColor'] = '#ffffff';
                        k['borderColor'] = '#65a30d';
                    }

                    let cncl_result = text.match(/cancel/gi) || text.match(/no/gi) || text.match(/close/gi) || text.match(/discard/gi) || text.match(/cancel/gi);
                    if (cncl_result) {
                        k['textColor'] = '#ffffff';
                        k['backgroundColor'] = '#636363';
                        k['borderColor'] = 'red';
                      
                    }

                    let del_result = text.match(/delete/gi) || text.match(/inactive/gi) || text.match(/remove/gi) || text.match(/disable/gi) || text.match(/Inactivate/gi);
                    if (del_result) {
                        k['textColor'] = '#ffffff';
                        k['backgroundColor'] = '#fb2727';
                        k['borderColor'] = 'red';
                    }



                }
            })
        }
    }

    onBtnClick(res): void {
        this.dialogRef.close(res);
    }

}